<template>
  <div>
    <v-app-bar flat app color="white">
      <v-btn text icon color="primary" @click="$router.go(-1)">
        <v-icon>mdi-arrow-left-thin-circle-outline</v-icon>
      </v-btn>

      <div class="d-flex flex-row align-center">
        <div v-if="Location">
          <div class="text-h5">{{ Location.name }}</div>
        </div>
        <v-progress-circular
          v-else
          indeterminate
          size="20"
          color="primary"
        ></v-progress-circular>

        <!-- <v-skeleton-loader type="heading"></v-skeleton-loader> -->
      </div>

      <v-spacer></v-spacer>
      <!-- <v-btn color="primary" v-if="!buyNow"  @click="buyNowPressed"
        >Buy Now</v-btn
      > -->
      <!-- <v-btn color="yellow" v-else rounded @click="placeOrder"
        >Place Order</v-btn
      > -->
    </v-app-bar>
    <v-container>
      <v-card outlined>
        <v-card-text>
          <div class="text-center">
            <div class="mt-4 display-3">Welcome</div>
            <div class="title font-weight-regular mb-8">
              Hardware for your software is here
            </div>
            <v-img
              alt="Cellsmart Logo"
              class="shrink mr-2"
              contain
              src="@/assets/samsungtab.png"
              transition="scale-transition"
              max-height="350"
            />
            <div class="mt-5">All set and ready to ship</div>
            <strong>Why buy from us?</strong>
            <div>Our device come with 6 month warranty</div>
            <div>All the app's are remove and hide</div>
            <div>Device set to stay always on</div>
            <div>CustomClockIn installed</div>
            <div>Ready to use</div>
            <div
              class="oldPrice mt-2 display-1 font-weight-light"
              v-if="basePrice !== sellingPrice"
            >
              {{ basePrice | currency }}
            </div>
            <div class="display-3 mt-2">{{ sellingPrice | currency }}</div>
            <div
              v-if="skipCount === 2"
              class="text--center red--text mt-2 font-weight-bold"
            >
              Our best and final price
            </div>
            <v-row class="mt-1">
              <v-col
                ><v-btn text v-if="!buyNow" @click="skip">skip</v-btn></v-col
              >
              <v-col>
                <v-btn color="primary" v-if="!buyNow" @click="buyNowPressed"
                  >Buy Now</v-btn
                >
              </v-col>
            </v-row>
            <div class="mt-3" v-show="buyNow">
              <div class="py-4 title">Address</div>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field
                    autofocus
                    type="text"
                    outlined
                    dense
                    :hide-details="addressLine1Errors.length === 0"
                    :background-color="`${
                      Address.addressLine1 ? false : 'yellow'
                    }`"
                    v-model="Address.addressLine1"
                    :error-messages="addressLine1Errors"
                    label="Address"
                    @focus="$event.target.select()"
                    @input="$v.Address.addressLine1.$touch()"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6"
                  ><v-text-field
                    type="text"
                    outlined
                    dense
                    hide-details
                    v-model="Address.addressLine2"
                    @focus="$event.target.select()"
                    label="Address Line 2"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    outlined
                    dense
                    :background-color="`${Address.city ? false : 'yellow'}`"
                    type="text"
                    v-model="Address.city"
                    :error-messages="cityErrors"
                    :hide-details="cityErrors.length === 0"
                    label="City"
                    @focus="$event.target.select()"
                    @input="$v.Address.city.$touch()"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-autocomplete
                    outlined
                    dense
                    :background-color="`${Address.StateId ? false : 'yellow'}`"
                    :items="states"
                    label="State"
                    :hide-details="stateIdErrors.length === 0"
                    :error-messages="stateIdErrors"
                    item-text="name"
                    item-value="id"
                    v-model="Address.StateId"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-text-field
                    outlined
                    dense
                    :background-color="`${
                      Address.postalCode ? false : 'yellow'
                    }`"
                    type="text"
                    :hide-details="postalCodeErros.length === 0"
                    :error-messages="postalCodeErros"
                    v-model="Address.postalCode"
                    label="Zip Code"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-autocomplete
                    outlined
                    dense
                    :background-color="`${
                      Address.CountryCode ? false : 'yellow'
                    }`"
                    :items="countries"
                    :error-messages="countryCodeErrors"
                    :hide-details="countryCodeErrors.length === 0"
                    label="Country"
                    item-text="name"
                    item-value="code"
                    v-model="Address.CountryCode"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <div class="mt-5" id="placeOrder">
                <v-btn color="yellow" rounded @click="placeOrder"
                  >Place Order</v-btn
                >
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import publicService from "@/api/public";
import locationService from "@/modules/Location/service.js";
import backofficeService from "@/modules/BackOffice/service.js";
const { validationMixin } = require("vuelidate");
const { required, minLength } = require("vuelidate/lib/validators");

export default {
  name: "order-hardware",
  data() {
    return {
      sellingPrice: 200,
      buyNow: false,
      basePrice: 200,
      skipCount: 0,
      states: [],
      countries: [],
      Address: {
        addressLine1: null,
        addressLine2: null,
        city: null,
        StateId: null,
        CountryCode: 840,
        postalCode: null,
      },
      Location: null,
    };
  },
  created() {
    this.getLocation();
    this.getState();
    this.getCountry();
    // console.log("location", this.$router.params);
    if (this.$router.params && this.$router.params.location) {
      this.Location = this.$router.params.location;
    }
  },
  computed: {
    addressLine1Errors() {
      const errors = [];
      if (!this.$v.Address.addressLine1.$dirty) return errors;
      if (!this.$v.Address.addressLine1.minLength)
        errors.push("Address must have at least 2 characters");
      if (!this.$v.Address.addressLine1.required)
        errors.push("Field Is Required");
      return errors;
    },
    cityErrors() {
      const errors = [];
      if (!this.$v.Address.city.$dirty) return errors;
      if (!this.$v.Address.city.required) errors.push("Field Is Required");
      return errors;
    },
    postalCodeErros() {
      const errors = [];
      if (!this.$v.Address.postalCode.$dirty) return errors;
      if (!this.$v.Address.postalCode.required)
        errors.push("Field Is Required");
      return errors;
    },
    stateIdErrors() {
      const errors = [];
      if (!this.$v.Address.StateId.$dirty) return errors;
      if (!this.$v.Address.StateId.required) errors.push("Field Is Required");
      return errors;
    },
    countryCodeErrors() {
      const errors = [];
      if (!this.$v.Address.CountryCode.$dirty) return errors;
      if (!this.$v.Address.CountryCode.required)
        errors.push("Field Is Required");
      return errors;
    },
  },
  watch: {
    buyNow(val) {
      if (val) {
        this.$vuetify.goTo(1000, { duration: 1000 });
        // const el = document.getElementById("placeOrder");
        // el.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
  methods: {
    randomIntFromInterval(min, max) {
      // min and max included
      return Math.floor(Math.random() * (max - min + 1) + min);
    },
    buyNowPressed() {
      this.buyNow = true;
      this.Address.addressLine1 = this.Location.Address.addressLine1;
      this.Address.addressLine2 = this.Location.Address.addressLine2;
      this.Address.city = this.Location.Address.city;
      this.Address.StateId = this.Location.Address.State.id;
      this.Address.postalCode = this.Location.Address.postalCode;
    },
    getLocation() {
      if (!this.$route.params || !this.$route.params.id) {
        return this.$router.go({ path: "/backoffice" });
      }

      const location = this.$route.params;
      this.locationId = this.$route.params.id;

      locationService.getById(location.id).then((response) => {
        this.Location = response.data;
      });
    },
    placeOrder() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$toast.error("Missing Fields", { timeout: 2000 });
        return false;
      }
      const obj = {
        sellingPrice: this.sellingPrice,
        Address: this.Address,
        Location: this.Location,
      };
      return backofficeService
        .orderHardware(obj)
        .then((response) => {
          console.log("response", response);
          this.$swal
            .fire({
              title: "Hardware Order",
              text: "Your order was pleased, We will ship it asap",
              icon: "success",
            })
            .then(() => {
              this.$router.push({
                path: `/backoffice/${this.Location.id}/location`,
              });
            });
        })
        .catch((error) => {
          console.log("error", error);
        });
      // this.$router.push({ path: "/backoffice" });
    },
    skip() {
      this.skipCount++;
      if (this.skipCount === 3) {
        this.$router.push({ path: "/backoffice" });
      } else {
        this.sellingPrice =
          this.basePrice - (this.basePrice * (this.skipCount * this.randomIntFromInterval(2,12))) / 100;
      }
    },
    getState() {
      return publicService.States().then((response) => {
        // console.log("responseresponse", response);
        this.states = response.data;
      });
    },
    getCountry() {
      return publicService.Country().then((response) => {
        // console.log("responseresponse", response);
        this.countries = response.data;
      });
    },
  },
  mixins: [validationMixin],
  validations: {
    Address: {
      addressLine1: {
        required,
        minLength: minLength(2),
      },
      city: {
        required,
      },
      postalCode: {
        required,
      },
      StateId: {
        required,
      },
      CountryCode: {
        required,
      },
    },
  },
};
</script>

<style scoped>
.oldPrice {
  text-decoration-line: line-through;
  text-decoration-color: red;
  text-decoration-style: wavy;
}
</style>